export default {
    aboutSeller: "про продавця",
    aboutProduct: "про товар",
    aboutUs: "Про нас",
    aboutAgrolink: "Про AGROLINK",
    absent: "вітсутня",
    accountDeleted:
        "Аккаунт заблокований. Зв'яжіться з адміністрацією для уточнення деталей.",
    actionRequireLogin: "Для здійснення цієї дії авторизуйтесь будьласка",
    activateError:
        "Помилка активації облікового запису. Зв'яжіться з адміністрацією.",
    activeIngredient: "Діюча речовина",
    actualBudget: "Фактичний бюджет",
    add: "Додати",
    addAttributeError: "Атрибут успішно додано",
    addAttributeSuccess: "Помилка при додаванні атрибута",
    editAttributeError: "Атрибут успішно відредаговано",
    editAttributeSuccess: "Помилка при редагуванні атрибута",
    addAttributeValueError: "Значение атрибута успішно додано",
    addAttributeValueSuccess: "Помилка при додаванні значения атрибута",
    editAttributeValueError: "Значение атрибут успішно відредаговано",
    editAttributeValueSuccess: "Помилка при редагуванні значения атрибута",
    addCategory: "Додати категорію",
    addCategoryMain: "Додати top категорію",
    addCondition: "Додати умову",
    addContract: "Додати договір",
    addMore: "Додати ще",
    address: "Адреса",
    addressDelivery: "Адреса доставки",
    addressFact: "Факт. Адреса",
    addressLaw: "Юр. Адреса",
    addFeedback: "Додати відгук",
    addSellerFeedback: "Додати відгук про продавця",
    addToBasket: "Додати в кошик",
    addToOften: "Додати в часті",
    addingProduct: "Додати товар",
    addFile: "Прикріпити файл",
    addProductError: "Помилка при додаванні товару",
    addProductSuccess: "Товар успішно додано",
    addPartner: "Додати партнера",
    editManufacturer: "Редагувати виробника",
    editPartner: "Редагувати партнера",
    agrarianReceipt: "Аграрна розписка",
    agrolinkManager: "Менеджер Агролінк",
    alias: "Аліас",
    alreadyInBasket: "Вже в кошику",
    and: "та",
    alreadyHaveAccount: "Вже є аккаунт ?",
    alreadyRegistered: "Вже зареєстровані?",
    all: "Всі",
    allAvailableProductsOnTheMarket: "Всі доступні товари на ринку",
    apply: "Застосувати",
    archive: "Архів",
    articleNumber: "Артикул",
    arriveDate: "Дата доставки",
    avatarDeleted: "Аватар видалено",
    authChecking: "Перевірка авторизації",
    avatarSettings: "Налаштування аватару",
    asSoonPossible: "Якомога швидше",
    attach: "Прикріпити",
    attribute: "Атрибут",
    attributeType: "Тип атрибута",
    attributeValue: "Значення атрибута",
    back: "Назад",
    backToOrders: "Повернутися до замовлень",
    bankName: "Назва банку",
    bankMfo: "МФО",
    bankAccount: "Розрахунковий рахунок",
    balance: "Залишок",
    balancePart: "Передплатна частина",
    basket: "Кошик",
    basketEmpty: "Ваш кошик пуст",
    before: "До",
    begin: "Почати",
    billOfExchange: "Авальований вексель",
    budget: "Бюджет",
    buyer: "Покупець",
    buyerRegistration: "Реєстрація для покупок",
    buyerRegWelcomeMessage:
        "Зареєструйтесь, щоб почати купляти напряму в постачальників",
    casePluralRu: "Відмінювання російською (мн.)",
    casePluralUa: "Відмінювання українською (мн.)",
    caseSingleRu: "Відмінювання російською (одн.)",
    caseSingleUa: "Відмінювання українською (одн.)",
    changeCode: "Змінити код",
    changeStatus: "Змінити статус",
    buy: "Купити",
    buyAllSellers: "Оформити всіх продавців",
    buyAgrolink: "Оформити через Agrolink",
    buyAll: "Оформити все",
    buyWithProduct: "З цим товаром купують",
    byDate: "За датою",
    byPriceMin: "За ціною (спочатку дешеві)",
    byPriceMax: "За ціною (спочатку дорогі)",
    byRating: "За рейтингом",
    byRecommendation: "За рекомендацією",
    byRequest: "На запит",
    byViews: "За переглядами",
    cancel: "Скасувати",
    cancelFilters: "Скинути",
    calculateTheCost: "Розрахувати вартість",
    calculationResult: "Результат калькуляцї",
    calculatorStep1stHeader:
        "Введіть будь ласка інформацію нижче і ми запропонуємо оптимальні варіанти захисту для поля. Всього три кроки і індівуальная тех. карта готова!",
    calculatorStep2ndHeader:
        "Будь ласка, виберіть кількість фаз обробки вашого поля і типи препаратів, які збираєтеся використовувати.",
    calculatorStep3rdHeader:
        "Тепер для ваших фаз обробки і типів препаратів вкажіть проблематику і бюджет на 1 гектар. Так Агролінк зможе підібрати найбільш точні варіанти продуктів.",
    calculatorStep4thHeader:
        "Ура! На Агролінк є результати за вашим параметрам. Виберіть один зі списку щоб препарат врахувався у бюджеті.",
    category: "Категорія",
    categoryAddError: "Помилка при додаванні категорії.",
    categoryAddSuccess: "Категорія успішно додана.",
    categoryUpdateError: "Помилка при оновленні категорії.",
    categoryUpdateSuccess: "Категорія успішно оновлена.",
    categoryDeleteError: "Помилка при видаленні категорії.",
    categoryDeleted: "Категорія видалена",
    categoryDeleteRestricted: "У категорії є дочірні категорії або товари. Видалення неможливе.",
    categoryRestoreConfirmation: "Відновити категорію",
    categoryRestoreError: "Помилка при відновленні категорії.",
    categoryRestoreSuccess: "Категорія успішно відновлена.",
    categoryBulkDeleteConfirmation: "Видалити вибрані категорії?",
    categoryBulkDeleteError: "Помилка при видаленні категорій.",
    categoryBulkDeleteRestricted: "Не можна видалити Top категорії або категорії з товарами.",
    categoryBulkDeleteSuccess: "Категорії успішно видалені.",
    catalog: "Каталог",
    categories: "Категорії",
    characteristics: "Характеристики",
    change: "Змінити",
    changesSaved: "Зміни збережені",
    changesStatus: "Змінити статус",
    changesSavedError: "Помилка при збереженні даних",
    cheap: "Дешеві",
    checkout: "Оформити",
    checkoutInBasket: "Оформити в кошику",
    checkoutProduct: "Оформити товар",
    checkoutProducts: "Оформити товари",
    chemicalClass: "Хімічний класс",
    choose: "Вибрати",
    chooseOneOption: "Оберіть один з варіантів",
    chooseContract: "Вибрати договір",
    chooseProblemsDrugTypes: "Оберіть проблематику для типів препарату",
    chooseTypesOfDrug: "Оберіть один або кілька типів препарата",
    codeUpdateError: "Помилка при оновленні коду.",
    codeUpdateSuccess: "Код успішно оновлено.",
    chooseVariants: "Оберіть варіанти",
    contactUs: "Зв'язатися з нами",
    city: "Місто",
    close: "Закрити",
    collapse: "Згорнути",
    comment: "Коментар",
    comments: "Коментарі",
    commonCost: "Загальна вартість",
    commonBudgetOnHectare: "Загальний бюджет обробки гектара",
    companies: "Компанії",
    company: "Компанія",
    companyLogo: "Лого компанії",
    companyDescriptionRu: "Опис компанії російською",
    companyDescriptionUa: "Опис компанії на українському",
    companyName: "Назва компанії",
    companyNameRu: "Назва компанії російською",
    companyNameUa: "Назва компанії на українському",
    companyRepresentatives: "Представники компанії",
    companyInfo: "Інформація про компанію",
    compare: "Порівняти",
    compareProducts: "Порівняти продукти",
    commercialPolicy: "Комерційна політика",
    commercialPolicies: "Комм. політика знижок",
    commentAboutCompany: "Залиште коментар про продукт",
    commission: "Комісія Liqpay",
    condition: "Умова",
    contact: "Контакт",
    contract: "Договір",
    contractAdded: "Договір доданий",
    contacts: "Контакти",
    contactsManager: "Контактні особи",
    contactsInfo: "Контактна інформація",
    contractual: "Договірна",
    confirm: "Підтвердити",
    copy: "Копіювати",
    costPerHectare: "Витраты на 1 гектар",
    credit: "Кредит",
    creditPart: "Кредитна частина",
    credentialsPassword: "Встановити пароль",
    credentialsWithEmail: "Встановити пароль та email",
    currency: "Валюта",
    culture: "Культура",
    customAttributesNames: {
        kultura: "Культура і норма використання",
    },
    dataErrorUpdated: "Помилка при оновленні даних",
    dataSuccessUpdated: "Дані успішно оновлені",
    date: "Дата",
    dateFrom: "дата от",
    dateTo: "дата до",
    delivery: "Доставка",
    deliveryDate: "Дата доставки",
    delete: "Видалити",
    deleteCategories: "Видалити категорії",
    deleteAvatar: "Видалити аватар",
    deliveryToAnywhere: "Доставка в будь-яку точку",
    department: "Відділ",
    deselectAll: "Скасувати виділення",
    description: "Опис",
    descriptionRu: "Опис товару на Російському",
    descriptionUa: "Опис товару на Українському",
    details: "Детали",
    dimensions: "Габарити",
    discount: "Знижка",
    discountByCommercialPolicy: "Знижка за комм. політикою",
    discountInPercent: "Знижка в %",
    diseases: "Захворювання",
    distributorRegions: "Регіони продавця",
    downloadPresentation: "Завантажити презентацію",
    doYouWantToDeleteSale: "Ви дійсно хочите відмовитись від продажу?",
    doYouWantToDeleteBought: "Ви дійсно хочите відмовитись від закупівлі?",
    drugEffectOnProblem: "Дія препарата на проблему",
    edit: "Редагувати",
    editCategory: "Редагувати категорію",
    edprou: "ЕГРПОУ",
    emptyBasket: "У Вашому кошику поки немає товарів",
    enter: "Увійти",
    enterBudget: "Введіть бюджет",
    enterRate: "Введіть бажану норму",
    enters: "Увійдіть",
    emailInvalid: "Введіть коректний email",
    emailRequired: "Вкажіть email",
    enterWithHelp: "увійти за допомогою",
    errorLoading: "Помилка при завантаженні даних",
    existence: "Наявність",
    exit: "Вихід",
    "exit?": "Вийти ?",
    expensive: "Дорогі",
    factoryDirectPriceWithoutSpeculation:
        "Пряма ціна від виробника без спекуляцій",
    favorites: "Вибране",
    farmziBenefits: "Переваги Агролінк",
    faqDialogTitle:
        "Заповніть будь ласка коротку форму і ми зв'яжемося з Вами найближчим часом",
    feedback: "Зворотній зв'язок",
    feedbackOne: "Відгук",
    feedbackMore: "Відгукі",
    feedbacks: "Відгуків",
    feedbackAboutCompany: "Відгуки про компанію",
    feedbackSend: "Відгук відправлений",
    fertilizers: "Добрива",
    firstName: "Ім'я",
    firstTimeAtFarmzi: "Вперше на AGROLINK?",
    filter: "Фільтр",
    filters: "Фільтри",
    filterBy: "Фільтрувати по",
    filterTo: "Фільтрувати",
    financeAndConfirmation: "Фінанси і підтвердження",
    for: "за",
    forAgriculturalProducer: "Для аграрія",
    forFarmer: "Для фермера",
    forCompany: "Для компанії",
    forPhase: "для фази",
    forSeller: "Для продавця",
    forgetPassword: "Забули пароль",
    forManufacturer: "Для виробника",
    from: "з",
    fromOt: "Від",
    fromCompany: "від компанії",
    fromSeller: "від продавця",
    freeRegistration: "Безкоштовна реєстрація",
    freeShipping: "Безкоштовна доставка",
    generalInfo: "Загальна інформація",
    getStartedAtFarmzi: "Почніть працювати на AGROLINK",
    goTo: "Перейти",
    height: "Висота",
    hello: "Вітаю",
    help: "Допомога",
    helpfulInfo: "Корисна інформація",
    helpCenter: "Довідковий центр",
    howToBuy: "Як робити закупки на AGROLINK",
    howToSell: "Як продавати на AGROLINK",
    homeFarmersText: [
        { id: 1, text: "1. Економія бюджету;" },
        {
            id: 2,
            text: "2. Швидкий пошук товарів за важливими характеристиками;",
        },
        { id: 3, text: "3. Порівняння товарів та усвідомлений вибір;" },
        { id: 4, text: "4. Актуальні ціни та наявність;" },
        { id: 5, text: "5. Зручна доставка по всій Україні." },
    ],
    homeManufacturersText: [
        {
            id: 1,
            text: "1. Збільшення продажів без виділення додаткового ресурсу компанії;",
        },
        {
            id: 2,
            text: "2. Допомога у логістиці та операційному документообігу;",
        },
        { id: 3, text: "3. Підтримка 24/7;" },
        { id: 4, text: "4. Безкоштовне розміщення на пробний період." },
    ],
    howFindUs: "Як ви про нас дізналися",
    howPlatformWorks: "Як працює онлайн платформа",
    iAgreeWith: "Згоден з",
    inBuy: "В закупівлю",
    homeHeadTitle:
        "Купуйте товари для поля онлайн з вигодою 5-15% безпосередньо від постачальників",
    homeWhatIs:
        "AGROLINK пропонує фермерам і виробникам інструментарій технологій для моніторингу цін, формування закупівлі, переговорів, підписання договору купівлі і автоматизації повторних закупівель",
    history: "Історія",
    inProcess: "В процесі",
    inStock: "В наявності",
    invalidValue: "Недійсне значення",
    inDevelopment: "Знаходиться в розробці",
    influenceType: "Тип впливу",
    issue: "Оформити",
    kg: "кг",
    lastEdit: "Остання зміна",
    lastName: "Прізвище",
    law: "Юридична особа",
    lawInfo: "Юридична інформація",
    length: "Довжина",
    linkCopied: "Лінк скопійовано",
    linkNotCopied: "Лінк не скопійовано",
    loadingPleaseWait: "Завантаження... будь ласка, зачекайте",
    login: "Вхід",
    loginWelcomeMessage: "Вас очікують сотні товарів",
    loginError: "Увійти не вдалося. Зв'яжіться з адміністрацією.",
    logout: "Вийти",
    longField: "Поле задовге",
    look: "Подивитися",
    lowLevel: "Закінчується",
    joinToAgrolink: "Приєднатися до Агролінк",
    link: "Посилання",
    knowPrice: "Дізнатись ціну",
    knowExistence: "Дізнатись наявність",
    mainData: "Основні дані",
    mainInfo: "Основна інформація",
    mainPage: "На головну",
    makeSellerOrder: "Оформити товари цього продавця",
    manualEntry: "Ввести норму вручну",
    manufacturersSelection: "Відбір виробників",
    manufacturers: "Обирайте товари і купуйте напряму у виробника",
    maxSum: "Макс. сума",
    mayBeSearch: "Можливо ви шукали",
    message: "Повідомлення",
    messages: "Повідомлення",
    messagesToSeller: "Повідомлення продавцю",
    messageSent: "Повідомлення відправлено",
    messageText: "Текст повідомлення",
    m: "м",
    minOrder: "Мін. замов.",
    minimumOrder: "Мінімальний лот продажу",
    minimumOrderUnit: "Мінімальний обсяг поставки",
    minimumOrderHelp:
        "Мін. замовлення буде також відображати кратність. Наприклад, ви продаєте 5 л каністри і вказали мін замовлення 4 каністри. Клієнт зможе купити 4, 8, 12, 16 і тд. каністр з кроком +4.",
    minSum: "Мін. сума",
    more: "Ще",
    moreDetails: "Детальніше",
    month: "Місяць",
    mostPopularProducts: "Найпопулярніші товари на Агролінк",
    myBasket: "Мої закупівлі",
    myContracts: "Мої договори",
    myInfo: "Моя інформація",
    myProducts: "Мої товари",
    mySales: "Мої продажі",
    myPurchases: "Мої закупівлі",
    name: "Найменування",
    nameSurname: "ПІБ",
    partnerAddError: "Не вдалося додати партнера",
    partnerAddSuccess: "Партнера успішно додано",
    partnerImage: "Логотип партнера",
    manufacturerImage: "Логотип виробника",
    partnerImageMaxSize: "Розмір логотипу не повинен перевищувати 2 МБ",
    partnerImageSizeHint: "Максимальний розмір зображення — 2 МБ",
    showcaseDetailsError: "Не вдалося отримати дані вітрини",
    showcaseUpdateError: "Не вдалося оновити запис вітрини",
    showcaseUpdateSuccess: "Запис вітрини успішно оновлено",
    nameRu: "Найменування на Російському",
    nameUa: "Найменування на Українському",
    needHelp: "Потрібна допомога?",
    newPurchase: "Нова закупівля",
    newsAndBlog: "Новини і блог",
    next: "Далі",
    noEnoughCompareProducts:
        "Поки ви додали один товар, додайте ще для порівняння",
    noData: "Нажаль, за обраними характеристиками товарів немає.",
    noCategoriesData: "На жаль, за обраними характеристиками категорії відсутні",
    noResult: "На жаль, немає результату за обраними параметрами",
    noOrders: "На жаль, замовлення відсутні",
    noUsers: "На жаль, користувачі відсутні.",
    noAccount: "Немає акаунту",
    noFeedbacks: "Відгуків про компанію немає, але ви можете стати першим!",
    noFeedbacksProduct: "Відгуків про товар немає, але ви можете стати першим!",
    noProducts: "У вас немає товарів у обраному...",
    norm: "Норма",
    notActivated:
        "Аккаунт не активоване. Перевірте вказаний email для активації облікового запису.",
    notAvailable: "Немає в наявності",
    notExistingPage:
        "Неправильно набрано адресу, або такої сторінки вже не існує.",
    notFound: "Нічого не знайдено",
    notUniqueValue: "Не уникальне значення",
    notes: "Примітки",
    numberOfDays: "Кіл-сть днів",
    numberOfMonths: "Кіл-сть місяців",
    numberOfHectares: "Кіл-сть гектар",
    numberOfTreatments: "Кіл-сть обробок",
    oftenSearched: "Найчастіше шукають",
    often: "Часті",
    or: "або",
    orderCreating: "Оформлення замовлення",
    orderDate: "Дата замовлення",
    orderEditing: "Редагування замовлення",
    orderError: "Помилка при оформленні товару",
    orderLot: "Одиниця замовлення",
    orderNumber: "Номер замовлення",
    orderNotFound: "Замовлення не найдено",
    orderPrice: "Сума замовлення",
    orderProducts: "Товари",
    orderRemoveError: "Помилка при видаленні замовлення",
    orderRemoveSuccess: "Замовлення успішно видалене",
    orderRemoved: "Замовлення видалене",
    orderSuccess: "Замовлення успішно оформленне",
    orderUpdated: "Замовлення змінене",
    orderUpdatedError: "Помилка при зміні замовлення",
    orderValue: "Обсяг закупівлі",
    otherSellers: "Інші продавці",
    packedBy: "Розфасоване по",
    packing: "Фасування",
    packType: "Тип упаковки",
    parentCategory: "Батьківська категорія",
    partners: "Наші партнери",
    passwordRequired: "Вкажіть пароль",
    payInfo: "Платіжна інформація",
    payment: "Оплата",
    paymentAndDelivery: "Оплата і доставка",
    paymentMethod: "Метод оплати",
    paymentWay: "Спосіб оплати",
    paymentWaySet: "Вкажіть спосіб оплати",
    personalCabinet: "Особистий кабінет",
    personalInfo: "Особиста інформація",
    personalProfile: "Особистий профіль",
    personalInfoSettings: "Налаштування особистої інформації",
    phoneNumber: "Номер телефону",
    pesticides: "Пестициди",
    physical: "Фізична особа",
    pickPassword: "Придумайте пароль",
    positiveFeedback: "Позитивних відгуків з",
    Prepayment: "Передоплата",
    price: "Ціна",
    "price&quantity": "Ціна і кількість",
    priceFrom: "Ціна от",
    priceTo: "Ціна до",
    priceAndAvailabilityInformationInTwoClicks:
        "Інформація про ціну і наявність в 2 кліка",
    priceWithNds: "Ціна вказана з урахуванням ПДВ",
    priceWithoutNds: "Ціна вказана без урахування ПДВ",
    priceWithDiscount: "Ціна зі знижкою",
    privacyAccept: "Ви повинні прийняти політику конфіденційності",
    privacyPolicy: "Політика конфіденційності",
    prepare: "Оформити цього продавця",
    problems: "Проблематика",
    problemsAndBudget: "Проблематика та бюджет",
    processingHectares: "обробки гектара",
    producer: "Виробник",
    productData: "Дані товару",
    productDescription: "Опис товару",
    productDeleted: "Товар вилучено",
    productEnumDialogMessage: "Зеленим кольором виділені проблеми які лікує",
    productFavoritesDelete: "Товар вилучений з обраного",
    productPage: "Сторінка товару",
    products: "Товарів",
    productsCategories: "Категорії товарів на агролінк",
    productsCount: "Всього товарів",
    productOrders: "Замовлення товара",
    productParams: "Характеристики товару",
    productsFound: "Товарів знайдено",
    productsManage: "Управління товарами",
    productsToOrder: "Товари до оформлення",
    productsAreNotProm: "Товари яких немає на Prom",
    productUpdating: "Редагуваня товара",
    productsWithDiscount: "Товари зі знижками",
    profileHeader: "Профіль користувача",
    profileSettings: "Налаштування профілю",
    promoSale: "Акція",
    provision: "Забезпечення",
    purchaseAmount: "Сума закупівлі",
    purchasingAtFarmzi: "Закупівля на AGROLINK це",
    quantity: "Кількість",
    quantityCut: "Кіл-ть",
    questionsAndAnswers: "Питання та відповіді",
    readMore: "Читати далі",
    realizationForm: "Форма реалізації",
    recommendedAccordingPacking: "Реком. замовлення відповідно до упаковки",
    recommendedRateByManufacturer:
        "Рекомендована норма використання від виробника",
    region: "Регіон",
    regions: "Регіони",
    regionSearch: "Пошук в регіоні",
    register: "Зареєструватися",
    registration: "Реєстрація",
    remove: "Вилучити",
    results: "Результати",
    return: "Повернути",
    retailPrice: "Роздрібна ціна ",
    resetPassword: "Скинути пароль",
    requiredField: "Обов'язкове поле",
    invalidSortOrder: "Введіть ціле число не менше 0",
    invalidUrl: "Введіть коректний URL",
    requiredQuantity: "Необхідна к-сть",
    requestPasswordError:
        "Помилка при запиті скидання пароля. Зв'яжіться з адміністрацією.",
    requestPassword: "Запросити скидання пароля",
    rowsPerPage: "Ряди на сторінці",
    saleUnit: "Одиниця продажу",
    save: "Зберегти",
    savePassword: "Зберегти пароль",
    saving: "Економія",
    section: "Розділ",
    selectAll: "Вибрати все",
    selectAllRegions: "Вибрати всі регіони",
    selectAttribute: "Виберіть атрибут",
    selectDate: "Вибрати дату",
    selectDateDelivery: "Виберіть дату поставки",
    selectPaymentMethod: "Виберіть метод сплати",
    selectFile: "Виберіть файл",
    selectedDrugs: "Вибрані препарати",
    seller: "Продавець",
    sellers: "Продавці",
    sellersProducts: "Товари продавця",
    sellerInformation: "Інформація про продавця",
    sellerRegistration: "Продавати на Агролінк",
    sellerRegWelcomeMessage:
        "Агролінк - це онлайн-платформа для прямої взаємодіі постачальника та аграрія. Ми працюємо тільки з виробниками і допомагаємо збільшити об'єм без виділення додаткового ресурсу.",
    seeds: "Насіння",
    seeMore: "подивитися ще",
    send: "Відправити",
    settlement: "Населений пункт",
    set: "Встановити",
    setRecommendOrderDate: "Вкажіть рекомендовану дату поставки",
    siteSearch: "Пошук",
    siteSearchBanner: "Пошук продуктів та виробників ...",
    size: "Розмір",
    shipmentAgrolink: "Відвантаження Агролінк",
    show: "Показати",
    sortBy: "Сортувати",
    specification: "Специфікація",
    specifyRateManually: "Вкажіть норму використання вручну",
    status: "Статус",
    sortOrder: "Порядок сортування",
    statusUpdateError: "Помилка оновлення статусу",
    statusUpdateSuccess: "Статус успішно оновлено",
    startSelling: "Почати продавати на Агролінк",
    stillQuestions: "Залишились запитання?",
    subCategories: "Підкатегорії",
    successfulAddedOften: "Успішно додано в часті",
    successfulDeletedOften: "Успішно видалено з частих",
    successfulDeleted: "Успішно видалено",
    sum: "Сума",
    sumMax: "Макс. сума",
    sumMin: "Мін. сума",
    summaryCost: "Підсумкова вартість",
    supplier: "постачальник",
    szr: "ЗЗР",
    targetBudget: "Заданий бюджет",
    telephone: "Телефон",
    thankYouForYourPurchase: "Дякую за оформлення закупівлі",
    thankYouForAddProduct: "Дякую за додавання товару",
    thankYouForFeedback: "Дякую за ваш зворотний зв'язок",
    thankYouForFaqMessage:
        "Дякую за звернення, зв'яжемося з Вами найближчим часом",
    thankYouForSellerRegistration:
        "Дякуємо за заявку на приєднання до спілки Agrolink! В Agrolink ми співпрацюємо з українськими та міжнародними брендами, щоб допомогти їм збільшувати продажі і розвивати свій бізнес. У зв'язку з цим ми приділяємо час перевірки кожного учасника. Ми зв'яжемося з вами найближчим часом!",
    theme: "Тема",
    toBasket: "В Кошик",
    toCatalog: "В каталог",
    total: "Разом",
    toPay: "До оплати",
    toProduct: "До товару",
    toPurchase: "В закупівлю",
    typesDrugsByPhase: "Типи препаратів за фазами",
    treaty: "Договірна",
    uah: "ГРН",
    updateCategory: "Змінити категорію",
    updateCategoryMain: "Змінити top категорію",
    updateOrder: "Змінити замовлення?",
    uploadImage: "Завантажити аватар",
    undefined: "Не вказано",
    unitOfMeasure: "Од. виміру",
    unitWeight: "Вага одиниці товару",
    userAgreement: "Угода користувача",
    userChecked: "Користувач підтверджений",
    userEditing: "Редагування користувача",
    view: "Вид",
    viewResults: "Показати результати",
    wantAddOften: "Додати в часті?",
    wantAddOftenSelected: "Додати вибрані в часті?",
    wantDeleteOften: "Видалити з частіх",
    wantDeleteOrder: "Видалити заявку?",
    wantRemoveAll: "Видалити все?",
    wantRemoveSelected: "Видалити відмічені?",
    whatIsFarmzi: "Що таке AGROLINK?",
    website: "Сайт",
    weight: "Вага упаковки",
    welcome: "Ласкаво просимо",
    wholesaleAgroPurchasingInSmartPhone: "Оптові Агро-Закупівлі В Смартфоні",
    wholesalePrice: "Оптова ціна",
    wholesaleFrom: "Опт від",
    width: "Ширина",
    withNds: "З ПДВ",
    withoutNds: "Без ПДВ",
    withPrivacyPolicy: "Політикою конфіденційності",
    withUserAgreement: "Угодою користовача",
    write: "Написати",
    writeToSeller: "Написати продавцеві",
    writeSellerFeedback: "Напишіть ваш відгук",
    withoutDelivery: "без доставки",
    wrongCredentials: "Введено неправильні email або пароль",
    yes: "Так",
    youMayLike: "Вам може сподобатися",
    youViewedEarlier: "Ви переглядали раніше",
    yourName: "Ваше ім'я",
    yourProductSaved: "Ваш товар успішно збережений!",
    dashboardClients: "Клієнти",
    dashboardProducts: "Товари",
    dashboardOrders: "Угоди",
    dashboardAttributes: "Атрибути",
    dashboardCategories: "Категорії",
    dashboardPartnerManufacturerShowcases: "Партнери та виробники",
    dashboardBuyers: "Покупці",
    dashboardSellers: "Продавці",
    dashboardNew: "Нові",
    dashboardTotal: "Всього",
    dashboardInStock: "В наявності",
    dashboardNotAvailable: "Немає в наявності",
    dashboardLowLevel: "Закінчується",
    dashboardReview: "На розгляді",
    dashboardInProgress: "В процесі",
    dashboardCancelled: "Скасовано",
    dashboardCompleted: "Завершено",
    dashboardEnumAttributes: "Enum",
    dashboardNumericAttributes: "Numeric",
    dashboardPublished: "Опубліковано",
    dashboardHidden: "Приховано",
    dashboardArchived: "В архіві",
    dashboardPartners: "Партнери",
    dashboardManufacturers: "Виробники",
    dashboardLoadError: "Не вдалося завантажити дані головної сторінки.",
};
